import fb from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyDK9fIfrq_uJwifcs_PliPYeZb-BBzvkgk",
    authDomain: "la-casa-das-entregas.firebaseapp.com",
    databaseURL: "https://la-casa-das-entregas-default-rtdb.firebaseio.com",
    projectId: "la-casa-das-entregas",
    storageBucket: "la-casa-das-entregas.appspot.com",
    messagingSenderId: "1028873137444",
    appId: "1:1028873137444:web:78fcfdbfa990ea193497b1",
    measurementId: "G-HHWJYD5BVP"
};

export let firebase = fb

export let app = fb.initializeApp(firebaseConfig)

export let db = app.database()

export let functions = app.functions()

export let auth = app.auth()

export let storage = app.storage()

export let messaging = app.messaging()